/**
 * @generated SignedSource<<132a67cd6a06ea0e8adbf0d8d07f6603>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type timeline_nativeIssueTable_TimelineCellRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"timelineCell_issueTableTimelineUI_fieldRef">;
  readonly " $fragmentType": "timeline_nativeIssueTable_TimelineCellRenderer";
};
export type timeline_nativeIssueTable_TimelineCellRenderer$key = {
  readonly " $data"?: timeline_nativeIssueTable_TimelineCellRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeline_nativeIssueTable_TimelineCellRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "timeline_nativeIssueTable_TimelineCellRenderer",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "timelineCell_issueTableTimelineUI_fieldRef"
        }
      ]
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "58d6df845c25bcf17f57eb5a180fe335";

export default node;
